import { tranStr } from "../../utils/translation";

export function columns() {
  return [
    {
      heading: tranStr("Name"),
      key: "project_name",
      type: "DESCRIPTION",
      width: 250,
      isFiltered: true,
    },
    {
      heading: tranStr("Type"),
      key: "project_type",
      type: "TEXT",
      width: 180,
      isFiltered: true,
    },
    {
      heading: tranStr("Sector"),
      key: "sector",
      type: "TEXT",
      width: 180,
      isFiltered: true,
    },
    {
      heading: tranStr("Subsector"),
      key: "sub_sector",
      type: "TEXT",
      width: 180,
      isFiltered: true,
    },
    {
      heading: tranStr("Quality"),
      key: "quality",
      type: "TEXT",
      width: 180,
      isFiltered: true,
    },
    {
      heading: tranStr("CBS"),
      key: "standard",
      type: "TEXT",
      width: 180,
      isFiltered: true,
    },
  ];
}
